/** Match backend E.164 rules */
export function normalizeInternationalPhone(input) {
  const raw = String(input || '').trim();
  if (!raw) return null;
  const digits = raw.replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length < 8 || digits.length > 15) return null;
  if (digits[0] === '0') return null;
  return `+${digits}`;
}

/** User object from /auth/me (camelCase) */
export function isMembershipShippingComplete(user) {
  if (!user) return false;
  const t = (v) => String(v ?? '').trim();
  if (!t(user.firstName) || !t(user.lastName)) return false;
  if (!normalizeInternationalPhone(user.phone)) return false;
  if (!t(user.shippingLine1)) return false;
  if (!t(user.shippingCity) || !t(user.shippingState) || !t(user.shippingCountry) || !t(user.shippingZipcode)) {
    return false;
  }
  return true;
}
